import { ProductFull } from "@api";
import { euStockedProductGroups } from "@/app/(site)/europe/constants";
import { ProductGroup } from "./ProductGroup";
import { SingularCard } from "./SingularCard";

export const EUStockedProducts = ({
  products,
}: {
  products: ProductFull[];
}) => {
  return (
    <>
      {/* Singular leads the section, ahead of the three stocked categories. */}
      <SingularCard />
      {euStockedProductGroups.map((group) => (
        <ProductGroup
          key={`eu-product-group-${group.categorySlug}`}
          group={group}
          products={
            group.slugs
              .map((slug) => products.find((p) => p.slug === slug))
              .filter((p) => p !== undefined) as ProductFull[]
          }
        />
      ))}
    </>
  );
};
